export const fmtINR = (n, opts = {}) => {
  const { compact = false, showSymbol = true, decimals = 2 } = opts;
  if (n === null || n === undefined || isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (compact) {
    if (abs >= 1e7) return `${showSymbol ? "\u20b9" : ""}${(n / 1e7).toFixed(2)} Cr`;
    if (abs >= 1e5) return `${showSymbol ? "\u20b9" : ""}${(n / 1e5).toFixed(2)} L`;
    if (abs >= 1e3) return `${showSymbol ? "\u20b9" : ""}${(n / 1e3).toFixed(1)}K`;
  }
  const v = new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(n);
  return showSymbol ? `\u20b9${v}` : v;
};

export const fmtUnits = (n, decimals = 4) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  }).format(n);
};

export const fmtPct = (n, decimals = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `${n >= 0 ? "+" : ""}${n.toFixed(decimals)}%`;
};

export const fmtNAV = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return `\u20b9${n.toFixed(4)}`;
};

export const shortDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
    });
  } catch (e) {
    return iso;
  }
};

export const longDate = (iso) => {
  try {
    return new Date(iso).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch (e) {
    return iso;
  }
};
